import { render, staticRenderFns } from "./UnidadeSetorOrigem.vue?vue&type=template&id=43f6d47e&"
import script from "./UnidadeSetorOrigem.vue?vue&type=script&lang=js&"
export * from "./UnidadeSetorOrigem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports